import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { SearchResponse, SearchResultWithState } from '@/types/api';

export function useSearch(query: string) {
  const [results, setResults] = useState<SearchResultWithState[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    const handle = setTimeout(() => {
      api
        .get<SearchResponse>(`/search?q=${encodeURIComponent(query)}`)
        .then((res) => !cancelled && setResults(res.results))
        .catch(() => !cancelled && setResults([]))
        .finally(() => !cancelled && setLoading(false));
    }, 180);
    return () => {
      cancelled = true;
      clearTimeout(handle);
    };
  }, [query]);

  return { results, loading };
}
